import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MapFieldsFormComponent } from './map-fields-form.component';
import { FilterlistPipeModule, SalesintelPrettyFieldPipeModule } from '../../../pipes';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {  MatFormFieldModule } from '@angular/material/form-field';
import {  MatSelectModule } from '@angular/material/select';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        FilterlistPipeModule,
        SalesintelPrettyFieldPipeModule,
        MatSlideToggleModule,
        MatFormFieldModule,
        MatSelectModule,
    ],
    declarations: [MapFieldsFormComponent],
    exports: [MapFieldsFormComponent]
})
export class MapFieldsFormModule {}
